module.exports = __webpack_public_path__ + "static/media/thank_you_page_header_logo.e56fcd43.png";